import { useGlobalBridge } from '@beefco/bridge';
import { useBusListener } from '@beefco/bus/react';
import { useEventListener } from '@beef/react';
import { ForwardNativeKeyboardEventCommand, ForwardNativeMouseEventCommand, ForwardedWheelEventCommand } from "../commands";
import { injectStandardEventProps, pickImportantKeyboardEventFields, pickImportantMouseEventFields } from "./helpers";
import { targetsInteractiveElement } from "../utils/checks";
import { ForwardedWheelEvent } from "../utils/events";
import { useTimeout } from "./useTimeout";

/**
 * Ловим нативные события клика и клавиатуры, и посылаем их в EventReceiver
 * Used in Project
 */
export var useEventTransmitter = function useEventTransmitter() {
  var globalBridge = useGlobalBridge();

  // FIXME: Optimize event count
  var forwardMouseEvent = function forwardMouseEvent(event) {
    globalBridge.bus.execute(new ForwardNativeMouseEventCommand(pickImportantMouseEventFields(event)));
  };
  var forwardKeyboardEvent = function forwardKeyboardEvent(event) {
    if (targetsInteractiveElement(event)) return;
    globalBridge.bus.execute(new ForwardNativeKeyboardEventCommand(pickImportantKeyboardEventFields(event)));
  };
  useEventListener('mousedown', forwardMouseEvent, window, {
    mode: {
      passive: true
    }
  });
  useEventListener('mousemove', forwardMouseEvent, window, {
    mode: {
      passive: true
    }
  });
  useEventListener('mouseup', forwardMouseEvent, window, {
    mode: {
      passive: true
    }
  });
  useEventListener('keydown', forwardKeyboardEvent, window, {
    mode: {
      passive: true
    }
  });
  useEventListener('keyup', forwardKeyboardEvent, window, {
    mode: {
      passive: true
    }
  });
  var timeout = useTimeout(50);
  useBusListener(ForwardedWheelEventCommand, function (event) {
    document.dispatchEvent(new ForwardedWheelEvent('wheel', injectStandardEventProps(event)));
  });
  useEventListener('wheel', function (event) {
    // Если событие было перенаправлено, то вероятно оно будет продолжаться по инерции
    // Даже если начнет происходить нативно (при смене между GUI & iFrame'ом)
    if (event.forwarded || timeout.test()) {
      timeout.reset();
      window.scrollTo({
        left: window.scrollX + event.deltaX,
        top: window.scrollY + event.deltaY
      });
    }
  });
};